<script>
import {copyText} from "@js/helpers.ts";
import OnlyDesktop from "@js/components/DynamicComponents/OnlyDesktop.vue";
import OnlyMobile from "@js/components/DynamicComponents/OnlyMobile.vue";
import {useThemeStore} from "@js/store/ThemeStore.js";

export default {
    name: "FirstPhone",
    components: {OnlyMobile, OnlyDesktop},
    data() {
        return {
            phone: "79014170477"
        };
    },
    computed: {
        formattedPhone() {
            return this.formatPhone(this.phone);
        }
    },
    methods: {
        formatPhone(number) {
            if (!number) return "";
            return number.replace(/^7(\d{3})(\d{3})(\d{2})(\d{2})$/, "+7 ($1) $2-$3-$4");
        },
        copyText() {
            copyText(this.formattedPhone);
            const themeStore = useThemeStore();
            themeStore.addToast("Телефон скопирован", "success");
        }
    }
};
</script>

<template>
    <div>
        <OnlyMobile>
            <a :href="'tel:+' + phone">
                {{ formattedPhone }}
            </a>
        </OnlyMobile>
        <OnlyDesktop>
            <div @click.prevent="copyText" class="cursor-pointer transition">
                {{ formattedPhone }}
            </div>
        </OnlyDesktop>
    </div>
</template>

<style scoped lang="scss">
</style>
